import { cx } from '@vizit/theme';
import * as React from 'react';
import { Input, type InputProps } from 'react-aria-components';

interface _InputProps extends InputProps {}

/**
 * The Input component is used to create an input field.
 *
 * @param props - The props for the Input component.
 * @example
 * <Input />
 */
const _Input = React.forwardRef((props: InputProps, ref: React.Ref<HTMLInputElement>) => {
  const { className, ...other } = props;

  return (
    <Input
      ref={ref}
      className={cx(
        'flex-1 font-regular',
        'bg-transparent',
        'border-none',
        'placeholder:text-placeholder',
        'focus:outline-none',
        'outline outline-0',
        'disabled:cursor-not-allowed disabled:bg-transparent',
        className,
      )}
      {...other}
    />
  );
});

export { _Input as Input };
export type { _InputProps as InputProps };
